import { MaterialTableColumnProps } from "../components/material-table/material-table";
import { formatLabel } from "./format-text";

export const SECTION_TYPES = {
  DEFAULT: "Default",
  FORM_SWITCH_SECTION: "Form switcher section",
}

export const responseItemDetailsColumns: MaterialTableColumnProps[] = [
  {
    header: "rental.crossHireRfq.table.vendor_header",
    accessorKey: "item_data.vendor_info.vendor_name",
    visible: true,
    type: "custom_link",
  },
  {
    header: "rental.crossHireRfq.table.rate_header",
    accessorKey: "rate",
    visible: true,
    type: "currency",
  },
  {
    header: "rental.crossHireRfq.table.minimum_order_quantity",
    accessorKey: "min_order_quantity",
    visible: true,
    type: "number",
  },
  {
    header: "rental.crossHireRfq.table.vendor_uom_header",
    accessorKey: "vendor_uom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "rental.crossHireRfq.table.specification_header",
    accessorKey: "specification",
    visible: false,
    type: "string",
  },
  {
    header: "rental.crossHireRfq.table.condition_header",
    accessorKey: "conditions",
    visible: false,
    type: "string",
  },
  // {
  //   header: "rental.crossHireRfq.table.notes_header", 
  //   accessorKey: "notes",
  //   visible: false,
  //   type: "string",
  // },
  {
    header: "rental.crossHireRfq.table.narration_header",
    accessorKey: "narration",
    visible: false,
    type: "string",
  },
];


export const INVENTORY_MATERIAL_COSTING_TYPE_ARR = [
  'pipe_costing',
  'boards_costing',
  'steel_sheets',
  'coil',
  'cuplock',
  "lvl_board",
  "ladder_aluminium",
  "ladder_beam",
  "flat_bar",
  "angles",
  "ladder_steel",
  "steel_board",
  'structural_fabrication'
]

export const INVENTORY_MATERIAL_COSTING_TYPE_OPTIONS = INVENTORY_MATERIAL_COSTING_TYPE_ARR.map((value) => ({ label: formatLabel(value), value }))

// Interface for form values
export type FieldDisableConfig = Record<string, any>;

export const INVENTORY_FIELDS_TO_BE_DISABLED: FieldDisableConfig = {
  pipe_costing: {
    tube_type: {
      Round: ['shape_width', 'shape_height'],
      Rectangular: ['tube_od',],
      Square: ['tube_od'],
      NO_VALUE: ['shape_width', 'shape_height', 'tube_od'],
    }
  },
  is_rental: {
    1: ['sales_price', 'alternative_product_sell', 'sales_description', "price_rules" , "sales_replacement_cost"],
    0: ['rental_base_price', 'rental_hour_fine', 'rental_day_fine', 'rental_security_time', "rental_prices", 'rental_description', "rental_replacement_cost"],
    true: ['sales_price', 'alternative_product_sell', 'sales_description', "price_rules" , "sales_replacement_cost"],
    false: ['rental_base_price', 'rental_hour_fine', 'rental_day_fine', 'rental_security_time', "rental_prices", 'rental_description', "rental_replacement_cost"],
    NO_VALUE: ['rental_base_price', 'rental_hour_fine', 'rental_day_fine', 'rental_security_time', "rental_prices", 'rental_description', "rental_replacement_cost" ],
  }
}

export const INVENTORY_ALWAYS_DISABLED_FIELDS = ['update_quantity', 'moves_history', 'variants', 'bom', 'location_wise_stock', 'purchase_price', 'base_unit'];
export const INVENTORY_ADD_MODE_DISABLED_FIELDS = ['vendor_information', 'update_quantity', 'moves_history', 'reordering_rules', 'variants', 'location_wise_stock', 'bin_wise_stock', 'serial_lot_wise_stock', 'bom'];
export const INVENTORY_EDIT_MODE_DISABLED_FIELDS = ['price_rules', 'variants', 'category', 'brand', 'traceability', 'bom', 'location_wise_stock', 'bin_wise_stock', 'serial_lot_wise_stock'];
export const INVENTORY_VARIANT_DISABLED_FIELDS = [
  'category',
  'parent_item',
  'attributes',
  'brand',
  'alternative_product_sell',
  // 'default_tax_id',
  // 'income_account_id',
  // 'asset_account_id',
  // 'cogs_account_id',
  'traceability',
  'location_wise_stock',
  'bin_wise_stock',
  'serial_lot_wise_stock'
];
